export const AdminConstants = {
    DIALOG_MESSAGE: 'You will lose any unsaved changes. Do you want to Continue?',
    LIVE_STATUS: 'LIVE',
    ACTIVE: 'Active'
};
